import { TipoGenericoRimovibile } from "../../tipologiche/tipo-generico-rimovibile";

export const tipiControbutoUnificatoOptions: TipoGenericoRimovibile[] = [
  {id: 'ESENZIONE', label: 'Esenzione', descrizione: 'Esenzione', rimosso: false},
  {id: 'IMPORTO', label: 'Importo fisso (manuale)', descrizione: 'Importo fisso (manuale)', rimosso: false},
  {id: 'SCAGLIONE', label: 'Calcolo a scaglioni', descrizione: 'Calcolo a scaglioni', rimosso: false},
];

export const scaglioniContributoUnificatoOptions: any[] = [
    { id: 'RIDUZIONE_50', label: 'Riduzione del 50%', valore: 'MINUS_50', percentuale: -50},
    { id: 'AUMENTO_50', label: 'Aumento del 50%', valore: 'PLUS_50', percentuale: 50},
    { id: 'AUMENTO_100', label: 'Aumento del 100%', valore: 'PLUS_100', percentuale: 100},
]